import { TransformKind, type ImageNode, type OrientationParams } from '@/core/document'
import { IDENTITY_ORIENTATION } from '@/core/geometry'
import type { EditSessionState } from '@/core/store/editSession'
import { selectSelectedNode } from '@/core/store/selectors'

function imageOrientation(node: ImageNode): OrientationParams {
  return node.transforms[TransformKind.Orientation] ?? IDENTITY_ORIENTATION
}

export function selectSelectedOrientation(state: EditSessionState): OrientationParams {
  const node = selectSelectedNode(state)
  return imageOrientation(node)
}
